export default __webpack_public_path__ + "static/media/readmos.6a73c82e.png";